import { render } from "./EmployeeOffDayHistory.vue?vue&type=template&id=2ad60d72"
import script from "./EmployeeOffDayHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeOffDayHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__